import {
  STYLE_BG_TOPBAR_PROGRAM,
  STYLE_TOPBAR_PROGRAM,
} from "../../../utils/useStyle";
import ProgramGoBackProgram from "./Program.GobackProgram";
import React from "react";
import { useEffect } from "react";
import { ContextLanguage } from "../../../context/Context.Language";

export const ProgramHeadScroll = ({ title, icon }) => {
  const [show, setShow] = React.useState(false);

  const { language } = React.useContext(ContextLanguage);

  useEffect(() => {
    try {
      setTimeout(() => {
        document?.addEventListener("scroll", () => {
          if (window?.scrollY >= 300) {
            setShow(true);
          } else if (window?.scrollY <= 300) {
            setShow(false);
          } else {
            setShow(false);
          }
        });
      }, 500);
    } catch (error) {
      window.location.reload();
    }
  }, []);

  return (
    <React.Fragment>
      {show && (
        <div className={STYLE_TOPBAR_PROGRAM}>
          <div className={STYLE_BG_TOPBAR_PROGRAM}>
            <ProgramGoBackProgram
              title={title}
              icon={icon}
              classNameIcon=" w-11"
              textcolor={` ${
                language === "TH" ? " text-lg-th " : " text-lg "
              } font-bold text-laudry-gray-200  `}
              classNameProgram=" mx-auto  h-11 pr-10"
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
